<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable max-len -->
<template>
  <Layout v-if="state$$.isVisible && !appState$$.inProgress && !appState$$.isOffline">
    <template #body>
      <Card
        :title="state$$.titlePage"
        :class="['card-register-custom', {
          'card-register-custom--tutorize': isTutorizeMode,
        }]"
      >
        <template #before__body>
          <div class="card-register__before-body">
            <div
              v-if="state$$.formRegister.step == 1 && !isTutorizeMode"
              class="card-register__before-body__text"
            >
              <p>
                {{ registerTexts['title'] }}
              </p>
            </div>

            <div
              v-else-if="(state$$.formRegister.step == 1 || state$$.formRegister.step == 2) && isTutorizeMode"
              class="card-register__before-body__text"
            >
              <p>
                {{ registerTexts['title-minor'] }}
              </p>
            </div>

            <div
              v-if="(state$$.formRegister.step == 2 && !isTutorizeMode) || (state$$.formRegister.step == 3 && isTutorizeMode)"
              class="card-register__before-body__text"
            >
              <p>
              </p>
              <p>
                {{ registerTexts['rule-phone-email'] }}
              </p>
            </div>
            <InlineMessage
              v-if="appState$$.isLogged && state$$.formRegister.step == 1"
              severity="info"
              class="border-primary w-full justify-content-start card-register__before-body__info"
            >
              <div class="flex align-items-center">
                <div class="ml-2">
                  La información correspondiente al nombre y los apellidos no
                  será considerada en el proceso de validación.
                </div>
              </div>
            </InlineMessage>
          </div>
        </template>

        <template #body>
          <div class="card-register">
            <div class="card-register__content">
              <Steppy
                v-model:step="state$$.formRegister.step"
                :tabs="state$$.formRegister?.tabsSteps"
                class="wrapper__steppy"
                :primary-color1="primaryColor"
                :primary-color2="stteperOffColor"
              >
              </Steppy>

              <div
                v-if="state$$.formRegister.step == 1"
                :class="['card-register__content__form card-register__content__form--step-1', {
                  'card-register__content__form--tutorize': isTutorizeMode,
                }]"
              >
                <Form
                  v-if="formConfig?.items?.length"
                  ref="$formRef"
                  :items="formConfig?.items"
                >
                  <template #validDateDNI__after>
                    <i
                      role="button"
                      tabindex="0"
                      class="form__item__validdatedni--icon pi pi-question-circle"
                      aria-label="Más información sobre la fecha de válidez del DNI"
                      @click="buildInfoIdentificationNumber"
                      @keydown.enter="buildInfoIdentificationNumber"
                    />
                  </template>

                  <template #supportNumber__after>
                    <i
                      role="button"
                      tabindex="0"
                      aria-label="Más información sobre el número de soporte"
                      class="form__item__supportnumber--icon pi pi-question-circle"
                      @click="buildInfoSupportNumber"
                      @keydown.enter="buildInfoSupportNumber"
                    />
                  </template>

                  <template #codIneMunicipio__option="{ option }">
                    <div
                      v-tooltip.right="{
                        value: `${option.municipality}`,
                        showDelay: 1000,
                      }"
                      class="flex align items-center gap-2 ineMunicipio__option"
                    >
                      <span>
                        {{ option.municipality }}
                      </span>
                    </div>
                  </template>

                  <template #codIneMunicipio__empty>
                    <span class="ineMunicipio__empty">
                      <span>No se han encontrado municipios de residencia.</span>
                      <span>Ingrese mínino 3 caracteres.</span>
                    </span>
                  </template>

                  <template #countryEU__option="slotProps">
                    <div class="flex align-items-center">
                      <img
                        v-if="slotProps.option.flag !== 'flag-cy'"
                        :alt="slotProps.option.nameSpanish"
                        src="https://primefaces.org/cdn/primevue/images/flag/flag_placeholder.png"
                        :class="`mr-2 flag ${slotProps.option.flag}`"
                        style="width: 18px"
                      />
                      <img
                        v-else
                        :alt="slotProps.option.nameSpanish"
                        src="~@/assets/images/cyprus-flag.png"
                        :class="`mr-2`"
                        style="width: 18px"
                      />
                      <div>{{ slotProps.option.nameSpanish }}</div>
                    </div>
                  </template>

                  <template #validDateDNI__previousicon>
                    <i class="pi pi-angle-left" />
                  </template>

                  <template #validDateDNI__nexticon>
                    <i class="pi pi-angle-right" />
                  </template>

                  <template #birthDate__previousicon>
                    <i class="pi pi-angle-left" />
                  </template>

                  <template #birthDate__nexticon>
                    <i class="pi pi-angle-right" />
                  </template>

                  <template #secondSurname__after>
                    <InlineMessage
                      v-if="
                        !state$$.secondSurnameDisclaimer && !appState$$.isLogged
                      "
                      class="card-register__requirement__message__disclaimer"
                      severity="warn"
                    >
                      Debe rellenar su segundo apellido si éste aparece en su
                      documento de identificación. En caso contrario debe
                      dejarlo vacío.
                    </InlineMessage>
                  </template>

                  <template #birthDate__after>
                    <InlineMessage
                      v-if="!state$$.birthDateRequirement"
                      class="card-register__requirement__message__text"
                      severity="error"
                    >
                      {{ getMessageErrorDate() }}
                    </InlineMessage>
                  </template>
                </Form>
              </div>
              <div
                v-if="state$$.formRegister.step == 2 && isTutorizeMode"
                :class="['card-register__content__form card-register__content__form--step-1', {
                  'card-register__content__form--tutorize': isTutorizeMode,
                }]"
              >
                <Form
                  v-if="formConfigMinor?.items?.length"
                  ref="$formMinorRef"
                  :items="formConfigMinor?.items"
                >
                  <template #validDateDNI__after>
                    <i
                      class="form__item__validdatedni--icon pi pi-question-circle"
                      @click="buildInfoIdentificationNumber"
                      @keydown.enter="buildInfoIdentificationNumber"
                    />
                  </template>

                  <template #supportNumber__after>
                    <i
                      class="form__item__supportnumber--icon pi pi-question-circle"
                      @click="buildInfoSupportNumber"
                      @keydown.enter="buildInfoSupportNumber"
                    />
                  </template>

                  <template #codIneMunicipio__option="{ option }">
                    <div
                      v-tooltip.right="{
                        value: `${option.municipality}`,
                        showDelay: 1000,
                      }"
                      class="flex align items-center gap-2 ineMunicipio__option"
                    >
                      <span>
                        {{ option.municipality }}
                      </span>
                    </div>
                  </template>

                  <template #codIneMunicipio__empty>
                    <span class="ineMunicipio__empty">
                      <span>No se han encontrado municipios de residencia.</span>
                      <span>Ingrese mínino 3 caracteres.</span>
                    </span>
                  </template>

                  <template #countryEU__option="slotProps">
                    <div class="flex align-items-center">
                      <img
                        v-if="slotProps.option.flag !== 'flag-cy'"
                        :alt="slotProps.option.nameSpanish"
                        src="https://primefaces.org/cdn/primevue/images/flag/flag_placeholder.png"
                        :class="`mr-2 flag ${slotProps.option.flag}`"
                        style="width: 18px"
                      />
                      <img
                        v-else
                        :alt="slotProps.option.nameSpanish"
                        src="~@/assets/images/cyprus-flag.png"
                        :class="`mr-2`"
                        style="width: 18px"
                      />
                      <div>{{ slotProps.option.nameSpanish }}</div>
                    </div>
                  </template>

                  <template #validDateDNI__previousicon>
                    <i class="pi pi-angle-left" />
                  </template>

                  <template #validDateDNI__nexticon>
                    <i class="pi pi-angle-right" />
                  </template>

                  <template #birthDate__previousicon>
                    <i class="pi pi-angle-left" />
                  </template>

                  <template #birthDate__nexticon>
                    <i class="pi pi-angle-right" />
                  </template>

                  <template #secondSurname__after>
                    <InlineMessage
                      v-if="
                        !state$$.secondSurnameDisclaimer && !appState$$.isLogged
                      "
                      class="card-register__requirement__message__disclaimer"
                      severity="warn"
                    >
                      Debe rellenar su segundo apellido si éste aparece en su
                      documento de identificación. En caso contrario debe
                      dejarlo vacío.
                    </InlineMessage>
                  </template>

                  <template #birthDate__after>
                    <InlineMessage
                      v-if="!state$$.birthDateRequirement"
                      class="card-register__requirement__message__text"
                      severity="error"
                    >
                      {{ getMessageErrorDate() }}
                    </InlineMessage>
                  </template>
                </Form>
              </div>
              <div
                v-if="(state$$.formRegister.step == 2 && !isTutorizeMode) || (state$$.formRegister.step == 3 && isTutorizeMode)"
                :class="['card-register__content__form card-register__content__form--step-2', {
                  'card-register__content__form--tutorize': isTutorizeMode,
                }]"
              >
                <Form
                  v-if="formConfigContact?.items?.length"
                  ref="$formContactRef"
                  :items="formConfigContact?.items"
                >
                  <template #emailValidation__after>
                    <div
                      v-if="showErrorEmailValidationRef"
                      class="field__form--error"
                      role="alert"
                    >
                      Las direcciones de correo electrónico no coinciden
                    </div>
                  </template>
                </Form>
                <div
                  v-if="showErrorEmailValidationGeneralRef"
                  class="field__form--error"
                  role="alert"
                >
                  Se debe de proporcionar al menos una dirección de correo
                  electrónico o un número de teléfono.
                </div>
              </div>
            </div>
            <div
              v-if="(state$$.formRegister.step == 1 && !isTutorizeMode) || (state$$.formRegister.step == 2 && isTutorizeMode)"
              class="card-register__captcha"
            >
              <Captcha
                ref="$captchaRef"
                v-model="captchaModel"
                class="card-register__captcha__field"
              />
            </div>
            <div class="card-register__keypad">
              <Button
                v-if="state$$.formRegister.step == 1 || (state$$.formRegister.step == 2 && isTutorizeMode)"
                class="bttn-AJ card-register__keypad__bttn p-button-secondary"
                label="Limpiar"
                aria-label="Limpiar formulario"
                tabindex="0"
                @click="clear"
                @keyup.enter="clear"
              />
              <Button
                v-if="state$$.formRegister.step == 2 || (state$$.formRegister.step == 3 && isTutorizeMode)"
                class="bttn-AJ card-register__keypad__bttn p-button-secondary"
                label="Volver"
                aria-label="Volver al paso anterior"
                tabindex="0"
                @click="returnStep"
                @keyup.enter="returnStep"
              />
              <Button
                class="bttn-AJ card-register__keypad__bttn card-register__keypad__bttn--primary"
                :label="state$$.formRegister.step == 1 || (state$$.formRegister.step == 2 && isTutorizeMode) ? 'Siguiente' : 'Registrar'
                "
                tabindex="0"
                :aria-label="state$$.formRegister.step == 1 || (state$$.formRegister.step == 2 && isTutorizeMode) ? 'Siguiente paso' : 'Registrar'"
                @click="submit"
                @keyup.enter="submit"
              />
            </div>
          </div>
        </template>
      </Card>
    </template>
  </Layout>

  <RegisterPrivacyPolicyModal
    v-if="state$$.policyModal.isVisible"
    ref="$contentModalRef"
  />

  <RegisterInfoSupporNumberDialog
    v-if="state$$.supportNumberInfo.isVisible"
    ref="$infoSupportNumberDialogRef"
  />

  <RegisterInfoIdentificationNumberDialog
    v-if="state$$.infoIdentificationNumber.isVisible"
    ref="$infoSupportNumberDialogRef"
  />
</template>

<script setup>
// #region Vue
import {
  inject,
  nextTick,
  computed,
  onMounted,
  provide,
  reactive,
  shallowRef,
  toRaw,
  watch,
  ref,
} from 'vue';
// #endregion

// #region Sttedra
import {
  Form,
  useDeleteNulls,
  useDev,
  useImmer,
  useNormalizer,
} from '@sttedra_ui/framework';
// #endregion

// #region Components
import Button from 'primevue/button/sfc';
import Card from '@/components/card/Card.vue';
import InlineMessage from 'primevue/inlinemessage/sfc';
import Layout from '@/components/layout/Layout.vue';
import RegisterInfoIdentificationNumberDialog from './RegisterInfoIdentificationNumberDialog.vue';
import RegisterInfoSupporNumberDialog from './RegisterInfoSupporNumberDialog.vue';
import RegisterPrivacyPolicyModal from './RegisterPrivacyPolicyModal.vue';
import Captcha from '@/components/captcha/Captcha.vue';
// #endregion

// #region Composables
import {Steppy} from 'vue3-steppy';
import {useDebounceFn} from '@vueuse/core';
import {useRouter} from 'vue-router';
import {useStore} from 'vuex';
import useComposeUser from '@/composables/compose-user';
import useHelpers from '@/composables/helpers';
import useManageApiError from '@/composables/manage-api-error';
import useValidationsRegister from '@/composables/validations-register';
import useThemeChange from '@/composables/use-theme-change';

import useDateRange from '@/composables/use-date-range';
// #endregion

// #region MODELS AND STATE
import useFormConfig from './form.view-config';
import useFormMinorConfig from './form-minor.view-config';
import useFormConfigContact from './form-contact.view-config';

import RegisterViewModel from './register.view-model';
import RegisterViewState from './register.view-state';

import RegisterUserModel from './register-user.view-model';
import RegisterUserViewModel from '@/shared/detail-resquet.view-model';
// #endregion

// #region API
import {StatusCodes as HttpStatus} from 'http-status-codes';

import {
  checkRegisterApplications as checkRegisterApplicationsApi,
  // preRegister as preRegisterApi,
  validatePreRegister as validatePreRegisterApi,
} from '@/api/register/register.api';

import {checkTokenLapsed as checkTokenLapsedApi} from '@/api/auth/auth.api';
// #endregion

// #region Params, Ref, Reactives, Computed
const TITLE_PAGE_ACCESS_WITH_CLAVE = 'Acceso con Cl@ve';
const HOME_ROUTE_NAME = 'Home';
const DETAIL_REQUEST_ROUTE_NAME = 'DetailRequest';
const typePortal = ref(STTEDRA_TYPE_PORTAL);

const appState$$ = inject('appState$$');
const router = useRouter();
const store = useStore();
const {primaryColor, stteperOffColor} = useThemeChange();

const registerTexts = computed(() => store.getters['text/getSectionTexts']('register'));
const isTutorizeMode = computed(() => store.getters['register/isTutorizeMode']);
const state = new RegisterViewState(isTutorizeMode.value);
const state$$ = reactive(state);

const model = new RegisterViewModel();
const {ref: modelRef /* , update: updateModel */} = useImmer(model);

let formConfig = null;
let formConfigMinor = null;
let formConfigContact = null;

const $formRef = shallowRef(null);
const $formMinorRef = shallowRef(null);
const $formContactRef = shallowRef(null);

const showErrorEmailValidationRef = shallowRef(false);
const showErrorEmailValidationGeneralRef = shallowRef(false);

const dateErrorRef = shallowRef(false);

const {getStartAndEndDates} = useDateRange();
const {composeUser} = useComposeUser();
const {supportNumValidationDNI, supportNumValidationNIE} = useValidationsRegister();

// captcha
const captchaModel = ref(null);
const $captchaRef = ref(null);

const {
  getObjectFilled,
  // getArrayFilled,
} = useNormalizer();

const {
  isSuccess,
  manageApiError,
  showErrorToast,
} = useManageApiError();

const {
  isDateBetween,
} = useHelpers();
// #endregion

// #region Functions
// #region SUBMIT FUNCTIONS
/**
 * Custom validate form
 *
 * @returns {boolean} True if the form is invalid
 */
async function formValidate() {
  const $formInstance = state$$.checkTutorizeInStep(2, true) ? $formMinorRef : $formRef;

  // Validate all fields
  await $formInstance.value.v$Ref.$validate();

  // Check if any field is invalid
  let staticField = [
    $formInstance.value.v$Ref.identificationNumber,
    $formInstance.value.v$Ref.name,
    $formInstance.value.v$Ref.secondSurname,
    $formInstance.value.v$Ref.surname,
  ];

  // Check if the user is not logged to remove some fields
  if (!appState$$.isLogged || typePortal.value === 'codigos') {
    staticField = [...staticField, $formInstance.value.v$Ref.birthDate];
  }

  if (state.formRegister.step === 1) {
    staticField = [
      ...staticField,
      $formInstance.value.v$Ref.checkPrivacyPolicy,
    ];
  }

  if (state$$.checkTutorizeInStep(1, true)) {
    staticField = [
      ...staticField,
      $formInstance.value.v$Ref.legalRelationshipType,
      $formInstance.value.v$Ref.checkMinor,
    ];
  } else {
    staticField = [
      ...staticField,
      $formInstance.value.v$Ref.codIneMunicipio,
    ];
  }

  const selectorAfterSupport = `.form__item__supportnumber--icon`;
  const afterFieldSupport = document.querySelector(selectorAfterSupport);
  if ($formInstance.value.v$Ref.supportNumber?.$invalid) {
    if (afterFieldSupport) {
      afterFieldSupport.classList.add('p-invalid');
    } else {
      afterFieldSupport.classList.remove('p-invalid');
    }
  }

  const selectorAfterDate = `.form__item__validdatedni--icon`;
  const afterFieldDate = document.querySelector(selectorAfterDate);
  if ($formInstance.value.v$Ref.validDateDNI?.$invalid) {
    if (afterFieldDate) {
      afterFieldDate.classList.add('p-invalid');
    } else {
      afterFieldDate.classList.remove('p-invalid');
    }
  }

  // Check if any of the fields is invalid
  const invalidStatic = staticField.some((field) => field.$invalid);
  if (invalidStatic) {
    return true;
  }

  // Check if the identification number is a NIE
  const value = $formInstance.value.getValues().identificationNumber;
  const isNie =
    value?.charAt(0).toUpperCase() === 'X' ||
    value?.charAt(0).toUpperCase() === 'Y' ||
    value?.charAt(0).toUpperCase() === 'Z';

  // Check if the date validate DNI is valid and if the identification number is a DNI
  if (
    $formInstance.value.v$Ref.validDateDNI?.$invalid &&
    !isNie &&
    !appState$$.isLogged
  ) {
    return true;
  }

  // Check if the support number nie is valid and if the identification number is a NIE
  if ($formInstance.value.v$Ref.supportNumber?.$invalid && isNie) {
    return true;
  }

  if (!state$$.birthDateRequirement) {
    return true;
  }

  if (!isTutorizeMode.value && $formInstance.value.v$Ref.codIneMunicipio?.$invalid) {
    return true;
  }

  // If all fields are valid return false
  return false;
}

/**
 *  Change the rules of the form depending on the type of identification number.
 * @param isNie {boolean} True if the identification number is a NIE
 */
async function onChangeRulesForm(isNie = false) {
  // Todo: conmutar entre instancias de form.
  const $formInstance = state$$.checkTutorizeInStep(2, true) ? $formMinorRef : $formRef;
  if (isNie) {
    $formInstance.value.state$$.rules.supportNumber.supportNumValidationNIE = supportNumValidationNIE;
    delete $formInstance.value.state$$.rules.supportNumber.supportNumValidationDNI;
  } else {
    $formInstance.value.state$$.rules.supportNumber.supportNumValidationDNI = supportNumValidationDNI;
    delete $formInstance.value.state$$.rules.supportNumber.supportNumValidationNIE;
  }
}

async function secondFormValidate() {
  const fields = [
    $formContactRef.value.v$Ref.email,
    $formContactRef.value.v$Ref.emailValidation,
    $formContactRef.value.v$Ref.phone,
  ];

  // Validate all fields
  await $formContactRef.value.v$Ref.$validate();

  if (fields.some((field) => field.$invalid)) {
    return true;
  }

  const {email, emailValidation, phone} = toRaw(
    $formContactRef.value.state$$.values,
  );

  if (email && email !== emailValidation) {
    showErrorEmailValidationRef.value = true;
    return true;
  }

  const emailField = document.querySelector('.form__item--email input');
  const phoneField = document.querySelector('.form__item--phone input');

  if (!phone && !email) {
    if (emailField) {
      emailField.classList.add('p-invalid');
    }

    if (phoneField) {
      phoneField.classList.add('p-invalid');
    }

    showErrorEmailValidationGeneralRef.value = true;
    return true;
  }

  const regex = /^\+\d{2,3} ?\d{3} ?\d{3} ?\d{3}$/;
  if (phone && !regex.test(phone)) {
    phoneField.classList.add('p-invalid');
    return true;
  }

  if (emailField) {
    emailField.classList.remove('p-invalid');
  }

  if (phoneField) {
    phoneField.classList.remove('p-invalid');
  }

  showErrorEmailValidationGeneralRef.value = false;
  showErrorEmailValidationRef.value = false;

  return false;
}

function formatDateString(valueInput) {
  const parts = valueInput.split('/');
  return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(
    2,
    '0',
  )}T00:00:00.000Z`;
}

function updateFormData(selector, statePath, data) {
  const inputElement = document.querySelector(selector + ' input');
  if (inputElement && inputElement.value.trim()) {
    const formattedDate = formatDateString(inputElement.value);
    if (formattedDate) {
      data[statePath] = formattedDate;
      if (state$$.checkTutorizeInStep(2, true)) {
        state$$.dataFormStep2Tutorize[statePath] = formattedDate;
      } else {
        state$$.dataFormStep1[statePath] = formattedDate;
      }
    }
  }
}

/**
 * Check if is visible the captcha.
 */
function isCaptchaVisible() {
  return $captchaRef?.value?.isCaptchaVisible() ?? false;
}

/**
 * Validate the firts form and send the data to the API.
 */
async function submitFirstForm() {
  // MOCK
  // state$$.formRegister.step = 2;
  // return;

  try {
    const invalid = await formValidate();

    if (invalid || (isCaptchaVisible() && captchaModel.value === null)) {
      if (state$$.checkTutorizeInStep(1, true) || state$$.checkTutorizeInStep(1, false)) {
        state$$.dataFormStep1 = null;
      } else if (state$$.checkTutorizeInStep(2, true)) {
        state$$.dataFormStep2Tutorize = null;
      }
      state$$.dataFormStep2 = null;

      const errorsFields = document.querySelectorAll('.form__group__error');
      let focused = false;
      if (errorsFields.length) {
        errorsFields.forEach((error) => {
          const small = error.querySelector('small');
          const input = error.previousSibling.querySelector(
            'input[tabindex=\'0\']',
          );
          if (input) {
            if (!focused) {
              focused = input;
            }

            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', small.id);
            input.setAttribute('aria-label', error?.textContent);

            small.setAttribute('aria-hidden', 'false');
            small.setAttribute('role', 'alert');
            small.setAttribute('aria-label', error?.textContent);
          }
        });

        if (!state$$.birthDateRequirement) {
          const selectorInput = `.form__item--${'birthDate'.toLowerCase()} input`;
          const inputField = document.querySelector(selectorInput);
          focused = inputField;
        }

        if (focused) {
          setTimeout(() => {
            focused.focus();
          }, 10);
        }
      }
      return;
    }

    const $formInstance = state$$.checkTutorizeInStep(2, true) ? $formMinorRef : $formRef;
    const data = toRaw($formInstance.value.state$$.values);

    if (state$$.checkTutorizeInStep(1, true) || state$$.checkTutorizeInStep(1, false)) {
      state$$.dataFormStep1 = new RegisterUserModel(data);
      if (!appState$$.isLogged) {
        updateFormData('.form__item--validdatedni', 'validDateDNI', data);
      }
      if (!appState$$.isLogged || typePortal.value === 'codigos') {
        updateFormData('.form__item--birthdate', 'birthDate', data);
      }
      if (state$$.checkTutorizeInStep(1, true)) {
        state$$.formRegister.step = 2;
        return;
      }
    }

    if (state$$.checkTutorizeInStep(2, true)) {
      const legalGuardian = data?.legalGuardian;
      state$$.dataFormStep2Tutorize = data;
      data.legalGuardian = new RegisterUserModel({
        ...legalGuardian,
        ...state$$.dataFormStep1,
      });
      if (!appState$$.isLogged) {
        updateFormData('.form__item--validdatedni', 'validDateDNI', data);
      }
      if (!appState$$.isLogged || typePortal.value === 'codigos') {
        updateFormData('.form__item--birthdate', 'birthDate', data);
      }
    }

    appState$$.setLoginApp(true);
    const {consolidationModel, response} = await validatePreRegisterApi(
      data,
      captchaModel.value,
    );

    appState$$.setLoginApp(false);
    state$$.formRegister.temporalToken =
      response?.headers?.['token-response'] || null;

    if (
      response?.status !== HttpStatus.OK &&
      response?.status !== HttpStatus.NO_CONTENT
    ) {
      state$$.dataFormStep1 = null;
      state$$.dataFormStep2Tutorize = null;
      state$$.formRegister.step = 1;
      state$$.formRegister.temporalToken = null;

      // TODO REINICIAR CAPTCHAS
      if (isCaptchaVisible()) {
        $captchaRef.value.resetCaptcha();
      }
      showErrorToast(`Ocurrio un error al intentar realizar el registro. 
        Por favor, inténtelo de nuevo más tarde. 
        Disculpe las molestias.`);

      return;
    }

    if (getObjectFilled(consolidationModel) && (consolidationModel?.stateId === 1 || consolidationModel?.stateId === 4) &&
    consolidationModel.notificable) {
      const dataModel = new RegisterUserViewModel(state$$.dataFormStep1);

      appState$$.detailRequest = {
        ...(dataModel || {}),
        ...consolidationModel,
        temporalToken: state$$.formRegister.temporalToken,
      };

      router.push({name: `DetailRequest`});
      return;
    }

    // appState$$.detailRequest = null;

    if (state$$.checkTutorizeInStep(2, true)) {
      state$$.formRegister.step = 3;
    } else {
      state$$.formRegister.step = 2;
    }

    if (isCaptchaVisible()) {
      $captchaRef.value.resetCaptcha();
    }
  } catch (err) {
    useDev.error('[Register] submitFirtsStep', err);
  }
}

/**
 * Validate the second form and send the data to the API.
 */
async function submitSecondForm() {
  try {
    const invalid = await secondFormValidate();
    if (invalid) {
      state$$.dataFormStep2 = null;
      const errorsFields = document.querySelectorAll('.form__group__error');
      if (errorsFields.length) {
        errorsFields.forEach((error, index) => {
          const small = error.querySelector('small');
          if (index === 0) {
            const input = error.parentElement.querySelector('input');
            setTimeout(() => {
              input.focus();
            }, 10);
          }

          small.setAttribute('aria-hidden', 'false');
          small.setAttribute('role', 'alert');
          small.setAttribute('aria-label', error?.textContent);
        });
      }
      return;
    }

    appState$$.setLoginApp(true);

    const data = toRaw($formContactRef.value.state$$.values);
    state$$.dataFormStep2 = data;

    const dataStep1form = isTutorizeMode.value ? state$$.dataFormStep2Tutorize : state$$.dataFormStep1;

    const dataModel = {
      ...dataStep1form,
      ...data,
    };

    appState$$.setLoginApp(false);

    appState$$.currentRequest = {
      ...dataModel,
    };

    appState$$.currentRequest.temporalToken =
      state$$.formRegister?.temporalToken;

    // appState$$.currentRequest.identificationNumber =
    //   state$$.dataFormStep1?.identificationNumber;

    appState$$.setLoginApp(true);
    router.push({name: `AcceptedRequest`});
  } catch (err) {
    useDev.error('[Register] submitSecondForm', err);
    appState$$.setLoginApp(false);
  }
}

const returnStep = useDebounceFn(returnStepFn, 200, {maxWait: 700});
async function returnStepFn() {
  if (state$$.checkTutorizeInStep(3, true)) { // contacto
    const data = new RegisterUserModel(
      appState$$?.currentRequest ?
        appState$$.currentRequest :
        state$$.dataFormStep2Tutorize,
    );

    state$$.dataFormStep2 = null;

    formConfigMinor = useFormMinorConfig({
      buildPolityModal,
      checkCorrectBirthDate,
      data,
      hideDisclaimerSecondSurname,
      isLogged: appState$$.isLogged,
      onChangeRulesForm,
      showDisclaimerSecondSurname,
    });

    state$$.dataFormStep2Tutorize.legalGuardian = data;
    state$$.formRegister.step = 2;
    // state$$.formRegister.temporalToken = null;
  } else if (state$$.checkTutorizeInStep(2, false) || state$$.checkTutorizeInStep(2, true)) {
    const data = new RegisterUserModel(
      appState$$?.currentRequest ?
        appState$$.currentRequest :
        state$$.dataFormStep1,
    );

    data.checkMinor = state$$.dataFormStep1?.checkMinor;
    data.checkPrivacyPolicy = state$$.dataFormStep1?.checkPrivacyPolicy;
    data.legalRelationshipType = state$$.dataFormStep1?.legalRelationshipType;

    formConfig = useFormConfig({
      buildPolityModal,
      checkCorrectBirthDate,
      data,
      hideDisclaimerSecondSurname,
      isLogged: appState$$.isLogged,
      onChangeRulesForm,
      isTutorizeRegister: isTutorizeMode.value,
      showDisclaimerSecondSurname,
    });

    if (state$$.checkTutorizeInStep(2, false)) {
      state$$.dataFormStep2 = null;
      // state$$.formRegister.temporalToken = null;
    } else if (state$$.checkTutorizeInStep(2, true)) {
      state$$.dataFormStep2Tutorize = null;
      state$$.birthDateRequirement = true;
    }

    state$$.formRegister.step = 1;
  }
}

const submit = useDebounceFn(submitFn, 200, {maxWait: 700});
/**
 * Submit the form.
 */
async function submitFn() {
  try {
    if (state$$.formRegister.step === 1 || state$$.checkTutorizeInStep(2, true)) {
      await submitFirstForm();
    } else if (state$$.checkTutorizeInStep(2, false) || state$$.checkTutorizeInStep(3, true)) {
      await submitSecondForm();
    }
  } catch (error) {
    useDev.error('[Register.vue] submit: Unexpected error:', error);
  }
}
// #endregion

// #region CAPTCHA FUNCTIONS

// #endregion

// #region APP FUNCTIONS
async function checkTokenValid() {
  const response = await checkTokenLapsedApi(appState$$?.token);
  const success = manageApiError(response);
  if (!isSuccess(success)) {
    defaultAppState();
    return false;
  }
  return true;
}

function defaultAppState() {
  appState$$.inProgress = false;
  appState$$.isLoading = false;
  appState$$.isLogged = false;
  appState$$.token = null;
}

async function checkRegisterApplications() {
  const {response, registerApplicationsModel} =
    await checkRegisterApplicationsApi(appState$$?.token);

  if (
    response.status === HttpStatus.OK &&
    getObjectFilled(registerApplicationsModel)
  ) {
    return registerApplicationsModel;
  }

  return false;
}
// #endregion

/**
 * Debounced function to clear the form.
 */
const clear = useDebounceFn(clearFn, 200, {maxWait: 700});

/**
 * Clears the form fields, resets CAPTCHA, and restores certain fields if the user is logged in.
 *
 * @async
 * @function clearFn
 */
async function clearFn() {
  if (state$$.checkTutorizeInStep(1, true) || state$$.checkTutorizeInStep(1, false)) {
    await clearFormStep1();
  }
}

/**
 * Clears the form fields for the first step.
 */
async function clearFormStep1() {
  try {
    const dataForm = {...toRaw($formRef.value.state$$.values)};

    // TODO REINICIAR CAPTCHAS
    if (isCaptchaVisible) {
      $captchaRef?.value?.resetCaptcha();
    }
    $formRef.value.clear();

    const calendarsField = ['validDateDNI', 'birthDate'];
    for (const field of calendarsField) {
      const selectorInput = `.form__item--${field.toLowerCase()} input`;
      const calendar = document.querySelector(selectorInput);
      if (calendar) {
        calendar.value = '';
      }
    }

    $formRef.value.changeFieldClassObj('validDateDNI', ['form-item--hidden']);

    await nextTick();

    if (appState$$.isLogged) {
      $formRef.value.changeFieldValue('identificationNumber', dataForm.identificationNumber);
      $formRef.value.changeFieldValue('name', dataForm.name);
      $formRef.value.changeFieldValue('surname', dataForm.surname);
      $formRef.value.changeFieldValue('secondSurname', dataForm.secondSurname);
    }
  } catch (error) {
    useDev.error('[Register.vue] clearFormStep1', error);
  }
}


/**
 * Shows the disclaimer for the second surname by updating the application state.
 *
 * @function showDisclaimerSecondSurname
 */
function showDisclaimerSecondSurname() {
  state$$.secondSurnameDisclaimer = false;
}

/**
 * Hides the disclaimer for the second surname by updating the application state.
 *
 * @function hideDisclaimerSecondSurname
 */
function hideDisclaimerSecondSurname() {
  state$$.secondSurnameDisclaimer = true;
}

/**
 * Validates the provided birth date and updates the form state and input field classes.
 *
 * @param {Date} date - The birth date to validate.
 */
function checkCorrectBirthDate(date) {
  try {
    const {minDate, maxDate: logicalMaxDate, textError} = getStartAndEndDates(
      state$$.checkTutorizeInStep(2, true) ? 2 : 1,
    );

    // Limitar el valor máximo a la fecha actual si es menor que el rango lógico
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const finalMaxDate = logicalMaxDate > today ? today : logicalMaxDate;

    dateErrorRef.value = textError;

    if (date && date.toString() !== 'Invalid Date') {
      date.setHours(0, 0, 0, 0);
      const validDate = isDateBetween(date, minDate, finalMaxDate);

      state$$.birthDateRequirement = validDate;
      validDate ? succesInputDate() : errorInputDate();
      return;
    }

    // Si no hay fecha válida, lo dejamos sin error pero sin valor
    succesInputDate();
    state$$.birthDateRequirement = true;
  } catch (error) {
    useDev.error('[Register.vue] checkCorrectBirthDate', error);
    succesInputDate();
    state$$.birthDateRequirement = true;
  }
}


/**
 * Corrects the input field classes for the birth date.
 * @param selector {string} The selector of the input field to correct.
 */
function succesInputDate(selector = '.form__item--birthdate input') {
  const inputField = document.querySelector(selector);
  if (inputField) {
    inputField.classList.remove('p-invalid');
  }
}

/**
 *  Corrects the input field classes for the birth date.
 * @param selector {string} The selector of the input field to correct.
 */
function errorInputDate(selector = '.form__item--birthdate input') {
  const inputField = document.querySelector(selector);
  if (inputField) {
    inputField.classList.add('p-invalid');
  }
}

/**
 * Gets the error message for the birth date based on the portal type.
 */
function getMessageErrorDate() {
  return dateErrorRef.value;
}

/**
 * Displays the Policy modal by toggling its visibility.
 *
 * @async
 * @function buildPolicyModal
 * @throws Will log an error if toggling the modal visibility fails.
 */
async function buildPolityModal() {
  await nextTick();
  state$$.toggleModalVisibility('policy');
}

/**
 * Displays the Support Number Information modal by toggling its visibility after a short delay.
 *
 * @async
 * @function buildInfoSupportNumber
 * @throws Will log an error if toggling the modal visibility fails.
 */
async function buildInfoSupportNumber() {
  await nextTick();
  setTimeout(() => {
    state$$.toggleModalVisibility('supportNumberInfo');
  }, 10);
}

/**
 * Displays the Identification Number Information modal by toggling its visibility after a short delay.
 *
 * @async
 * @function buildInfoIdentificationNumber
 * @throws Will log an error if toggling the modal visibility fails.
 */
async function buildInfoIdentificationNumber() {
  await nextTick();
  setTimeout(() => {
    state$$.toggleModalVisibility('infoIdentificationNumber');
  }, 10);
}

/**
 * Redirects the user based on their authentication status and application registration.
 *
 * - Sets the page title.
 * - Checks if the authentication token is valid.
 *   - If invalid, redirects to the Home page.
 * - Checks if there are registered applications.
 *   - If applications are found, updates the application state and redirects to the Detail Request page.
 *
 * @async
 * @function redirectIfLogged
 * @throws Will log an error if any step in the redirection process fails.
 */
async function redirectIfLogged() {
  try {
    state$$.titlePage = TITLE_PAGE_ACCESS_WITH_CLAVE;

    const isTokenValid = await checkTokenValid();
    if (!isTokenValid) {
      await routerPushWithNextTick(HOME_ROUTE_NAME);
      return true;
    }

    const registeredApplications = await checkRegisterApplications();
    if (getObjectFilled(registeredApplications)) {
      appState$$.setLoginApp(true);
      appState$$.detailRequest = {
        ...registeredApplications,
        temporalToken: state$$.formRegister.temporalToken,
      };

      await routerPushWithNextTick(DETAIL_REQUEST_ROUTE_NAME);
      return true;
    }
  } catch (error) {
    useDev.error('[AuthenticationRedirect.js] redirectIfLogged', error);
  }

  return false;
}

/**
 * Navigates to a specified route and ensures the DOM is updated.
 *
 * @async
 * @function navigateToRoute
 * @param {string} routeName - The name of the route to navigate to.
 * @throws Will throw an error if navigation fails.
 */
function navigateToRoute(routeName) {
  try {
    router.push({name: routeName});
  } catch (error) {
    throw new Error(`Failed to navigate to route "${routeName}": ${error.message}`);
  }
}

/**
 * Navigates to a specified route and waits for the DOM to update.
 *
 * @async
 * @function routerPushWithNextTick
 * @param {string} routeName - The name of the route to navigate to.
 * @throws Will throw an error if the router fails to navigate.
 */
async function routerPushWithNextTick(routeName) {
  try {
    router.push({name: routeName});
    await nextTick();
  } catch (error) {
    throw new Error(`Failed to navigate to route "${routeName}": ${error.message}`);
  }
}

/**
 * Handles new registration data by composing user information and configuring forms.
 *
 * @async
 * @function handleNewRegistrationData
 * @param {boolean} isLogged - Indicates if the user is logged in.
 * @param {string} token - The user's authentication token.
 * @param {boolean} isTutorizeRegister - Indicates if the registration is through Tutorize.
 * @throws Will throw an error if any step in the process fails.
 */
async function handleNewRegistrationData(isLogged, token, isTutorizeRegister) {
  let data = new RegisterUserModel(appState$$?.detailRequest);
  useDeleteNulls(data);

  if (!getObjectFilled(data)) {
    data = composeUser({isLogged, token});
    data = new RegisterUserModel(data);
    useDeleteNulls(data);
  }

  await nextTick();

  formConfig = useFormConfig({
    buildPolityModal,
    checkCorrectBirthDate,
    data,
    hideDisclaimerSecondSurname,
    isLogged,
    onChangeRulesForm,
    isTutorizeRegister,
    showDisclaimerSecondSurname,
  });

  if (isTutorizeMode.value) {
    formConfigMinor = useFormMinorConfig({
      buildPolityModal,
      checkCorrectBirthDate,
      data: {},
      hideDisclaimerSecondSurname,
      isLogged,
      onChangeRulesForm,
      showDisclaimerSecondSurname,
    });
  }

  formConfigContact = useFormConfigContact({data});

  await nextTick();
}

/**
 * Handles existing registration requests by configuring form data and navigating accordingly.
 *
 * @async
 * @function handleExistingRegistrationRequest
 * @param {boolean} isTutorizeRegister - Indicates if the registration is through Tutorize.
 * @param {boolean} isLogged - Indicates if the user is logged in.
 * @param {string} token - The user's authentication token.
 * @throws Will throw an error if any step in the process fails.
 */
async function handleExistingRegistrationRequest(isTutorizeRegister, isLogged) {
  state$$.formRegister.step = isTutorizeMode.value ? 3 : 2;

  const {
    birthDate,
    codIneMunicipio,
    email,
    emailValidation,
    identificationNumber,
    name,
    phone,
    secondSurname,
    supportNumber,
    surname,
    validDateDNI,
    legalGuardian,
  } = appState$$?.currentRequest;

  if (isTutorizeMode.value) {
    state$$.dataFormStep1 = {
      ...legalGuardian,
      checkPrivacyPolicy: true,
      checkMinor: true,
    };

    state$$.dataFormStep2Tutorize = {
      birthDate,
      // checkPrivacyPolicy: true,
      codIneMunicipio,
      identificationNumber,
      name,
      secondSurname,
      supportNumber,
      supportNumber,
      surname,
      validDateDNI,
    };

    const formData2 = new RegisterUserModel(state$$.dataFormStep2Tutorize);
    useDeleteNulls(formData2);
    formConfigMinor = useFormMinorConfig({
      buildPolityModal,
      checkCorrectBirthDate,
      data: formData2,
      hideDisclaimerSecondSurname,
      isLogged,
      isTutorizeRegister,
      onChangeRulesForm,
      showDisclaimerSecondSurname,
    });
  } else {
    state$$.dataFormStep1 = {
      birthDate,
      checkPrivacyPolicy: true,
      codIneMunicipio,
      identificationNumber,
      name,
      secondSurname,
      supportNumber,
      supportNumber,
      surname,
      validDateDNI,
    };
  }

  const formData1 = new RegisterUserModel(state$$.dataFormStep1);
  useDeleteNulls(formData1);

  formConfig = useFormConfig({
    buildPolityModal,
    checkCorrectBirthDate,
    data: formData1,
    hideDisclaimerSecondSurname,
    isLogged,
    isTutorizeRegister,
    onChangeRulesForm,
    showDisclaimerSecondSurname,
  });

  state$$.dataFormStep2 = {
    email,
    emailValidation,
    phone,
  };

  formConfigContact = useFormConfigContact({
    data: state$$.dataFormStep2,
  });

  await nextTick();

  appState$$.setLoginApp(false);
  state$$.formRegister.temporalToken = appState$$.currentRequest?.temporalToken;
  state$$.setVisibility(true);
}
// #endregion

// #region Effects, Hooks
onMounted(async () => {
  try {
    appState$$.setLoginApp(true);
    state$$.setVisibility(false);

    if (appState$$.isOffline) {
      navigateToRoute(router, HOME_ROUTE_NAME);
      return;
    }
    const isTutorizeRegister = isTutorizeMode.value;

    const isLogged = appState$$.isLogged;
    if (isLogged && !isTutorizeRegister) {
      if (await redirectIfLogged()) {
        return;
      }
    }

    const token = appState$$.token;

    if (appState$$?.currentRequest) {
      await handleExistingRegistrationRequest(isTutorizeRegister, isLogged);
      return;
    }

    await handleNewRegistrationData(isLogged, token, isTutorizeRegister);

    appState$$.setLoginApp(false);
    state$$.setVisibility(true);
  } catch (error) {
    useDev.error('[Register.vue] onMounted', error);
  }
});

watch(
  () => state$$.formRegister.step,
  () => {
    const prefix = appState$$.isLogged ? 'Acceso con Cl@ve' : 'Datos personales';
    if (state$$.checkTutorizeInStep(2, false) || state$$.checkTutorizeInStep(3, true)) {
      state$$.titlePage = 'Datos de contacto';
      return;
    } else if (state$$.checkTutorizeInStep(2, true)) {
      state$$.titlePage = `Datos personales del menor`;
      return;
    } else if (state$$.checkTutorizeInStep(1, true)) {
      state$$.titlePage = `${prefix} del tutor`;
      return;
    } else if (state$$.checkTutorizeInStep(1, false)) {
      state$$.titlePage = `Datos personales`;
      return;
    }
  },
);
// #endregion

// #region Provide, Expose
provide('registerState$$', state$$);
provide('registerModel', {modelRef});
// #endregion
</script>

<style lang="scss" scoped>
@use "@/styles/vars" as *;
@use "@/styles/breakpoints" as *;
@use "@/styles/flags" as *;

$form_width: 550px;

.card-register {
  -ms-flex-direction: column;
  -webkit-box-direction: normal;
  -webkit-box-orient: vertical;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  gap: $brand__boxspace--medium;
  max-width: $form_width !important;

  &__before-body {
    max-width: $form_width !important;
    :deep()
    &__text {
      & p {
        @include media("<=phone") {
          font-size: $pv__fs--large;
          text-align: center;
        }

        @include media(">phone") {
          font-size: 0.9rem;
        }
      }
    }

    &__info {
      background-color: $pv__color--white;
      border-radius: $pv__br--xxlarge;
      border-width: 1px 1px 1px 1px;
      border: solid $pv__color--green-alter;
      color: $pv__color--black;

      :deep(.p-icon) {
        color: $pv__color--green-alter;

        @include media("<=phone") {
          width: 6rem;
          height: 6rem;
        }

        @include media(">phone") {
          width: 3rem;
          height: 3rem;
        }
      }
    }
  }

  &__requirement__message {
    margin: auto;

    &__text {
      background: transparent;
      color: $pv__color--red !important;
      margin-top: 0.25rem;
      padding-left: 0;
      width: 100%;

      :deep(.p-icon) {
        display: none !important;
      }
    }

    &__disclaimer {
      margin-top: 0.5rem;

      :deep(.p-icon) {
        display: none !important;
      }
    }
  }

  &__content {
    -ms-flex-direction: column;
    -webkit-box-direction: normal;
    -webkit-box-orient: vertical;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    flex-direction: column;
    gap: $brand__boxspace--medium * 2;
    &__form {
      // max-width: 420px;

      &--tutorize {
        // max-width: 520px;
      }

      @include media("<=phone") {
        max-width: inherit;
        min-width: 200px;
      }

      &__recaptcha {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        justify-content: center;
        margin-top: $brand__boxspace--medium;
      }
    }

    &__form--step-1 {
      :deep(.form) {
        .form__item {
          .p-inputtext {
            text-transform: uppercase !important;
          }
        }
      }
    }
  }

  &__keypad {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: ($brand__boxspace--medium * 1);
    justify-content: center;
    align-items: center;

    @include media("<=phone") {
      -ms-flex-align: center;
      -ms-flex-direction: column-reverse;
      -ms-flex-pack: center;
      -webkit-box-align: center;
      -webkit-box-direction: reverse;
      -webkit-box-orient: vertical;
      -webkit-box-pack: center;
      align-items: center;
      flex-direction: column-reverse;
      justify-content: center;
    }

    @include media(">tablet") {
      -ms-flex-direction: row;
      -ms-flex-pack: center;
      -webkit-box-direction: normal;
      -webkit-box-orient: horizontal;
      -webkit-box-pack: center;
      flex-direction: row;
      justify-content: center;
    }

    &__bttn {
      width: auto;

      @include media("<=tablet") {
        width: 100% !important;
      }

      &--primary{
        background-color: var(--primary-800);
      }
    }
  }

  &__captcha {
    display: flex;
    justify-content: center;
    &__field{
      margin-bottom: 2rem;
    }
  }
}

:deep(.form__item--supportnumber) {
  align-items: center;
  position: relative;

  .form__item__supportnumber--icon {
    color: $pv__color--green-alter;
    cursor: pointer;
    font-size: $pv__fs--xlarge;
    grid-row: 1;
    justify-self: end;
    margin-right: 0.5rem;
    position: absolute;

    &:focus {
      outline: 2px solid $pv__color--green-alter;
    }
  }

  .form__group__error+.form__item__supportnumber--icon {
    top: 9px;
  }

  .form__item__supportnumber--icon:hover {
    color: $pv__color--black;
  }

  .form__group__error {
    grid-row: 2;
  }
}

:deep(.form__item--validdatedni) {
  align-items: center;
  position: relative;

  .form__item__validdatedni--icon {
    color: $pv__color--green-alter;
    cursor: pointer;
    font-size: $pv__fs--xlarge;
    grid-row: 1;
    justify-self: end;
    margin-right: 4rem;
    position: absolute;

    &:focus {
      outline: 2px solid $pv__color--green-alter;
    }
  }

  .form__group__error+.form__item__validdatedni--icon {
    top: 9px;
  }

  .form__item__validdatedni-icon:hover {
    color: $pv__color--black;
  }

  .form__group__error {
    grid-row: 2;
  }
}

:deep(.form__item--codinemunicipio) {
  .ineMunicipio__option {
    span {
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .ineMunicipio__empty {
    display: flex;
    flex-direction: column;
    font-size: $pv__fs--medium;
    gap: 0.25rem;
    padding: $brand__boxspace--small;
  }
}
:deep(.card-register-custom) {
  .card__header{
    max-width: $form_width !important;
  }
  .card__body{
    max-width: $form_width !important;
    width: 100%;
    margin: 0 !important;
  }
}
</style>
